import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { useI18n } from '@design-system/i18n';
import { UsersAvatarList } from '@design-system/users-avatar-list';
import { Cover } from './Cover';
import { GroupAndContentType } from './GroupAndContentType';
import { LinkWrapper } from './LinkWrapper';
import { CONTENT_LIST_SIZES } from '../constants';
import { getGroupPresentationImageWrapperSizes } from '../utils';
const DEFAULT_DISPLAY_FIELDS = {
    contentType: false,
    avatars: false,
    location: false,
    members: false,
};
export const GroupPresentation = ({ contentTypeName, data: { image, location, members, membersLabel, name, seeMoreOnClick, totalMembers, }, displayFields = DEFAULT_DISPLAY_FIELDS, onClick, path, size, withLink, }) => {
    const { __ } = useI18n();
    const canReturnTotalMembers = displayFields.members && !displayFields.avatars;
    const canDisplayLocation = displayFields.location && location;
    const displaySeparationDot = canReturnTotalMembers && membersLabel && canDisplayLocation;
    const groupMembers = members
        ? members === null || members === void 0 ? void 0 : members.map((user, index) => {
            var _a;
            return ({
                id: (_a = user.id) !== null && _a !== void 0 ? _a : index,
                name: user.name,
                photo_thumb_url: user.photo_thumb_url,
            });
        })
        : [];
    return (_jsxs(Box, { flexDirection: { _: 'column', m: 'row' }, width: "100%", children: [_jsx(ImageWrapper, { "$size": size, children: _jsx(Cover, { fallbackIconName: "user-group", imageSrc: image, onClick: onClick, path: path, size: size, withLink: withLink }) }), _jsxs(Box, { flexDirection: "column", justifyContent: "center", maxWidth: { _: '100%', m: '60%' }, children: [displayFields.contentType && (_jsx(GroupAndContentType, { type: displayFields.contentType
                            ? contentTypeName !== null && contentTypeName !== void 0 ? contentTypeName : __('Group')
                            : undefined })), _jsx(Box, { mb: 1, children: _jsx(LinkWrapper, { font: "h4-semibold", onClick: onClick, path: path, withLink: withLink, children: _jsx(Dotdotdot, { clamp: 2, children: name }) }) }), _jsx(Box, { children: size === CONTENT_LIST_SIZES.SMALL ? (_jsxs(Box, { flexDirection: "column", children: [canDisplayLocation && _jsx(Box, { mb: 1, children: location }), canReturnTotalMembers && (_jsx(Box, { font: "body-semibold-asphalt", children: membersLabel }))] })) : (_jsxs(Box, { display: "block", children: [_jsx("span", { children: canReturnTotalMembers && membersLabel }), displaySeparationDot && _jsx("span", { children: "\u00A0\u00B7\u00A0" }), _jsx("span", { children: displayFields.location && location })] })) }), displayFields.avatars && members && (_jsx(Box, { mt: size === CONTENT_LIST_SIZES.SMALL ? 1 : 2, children: _jsx(UsersAvatarList, { maxAvatars: 3, onClickMore: seeMoreOnClick, totalUsers: totalMembers, users: groupMembers }) }))] })] }));
};
const ImageWrapper = styled(Box).attrs(({ $size }) => {
    const sizes = getGroupPresentationImageWrapperSizes($size);
    return {
        alignSelf: 'flex-start',
        maxWidth: sizes.maxWidth,
        minWidth: sizes.minWidth,
        mr: sizes.mr,
        mb: { _: 3, m: 0 },
    };
}) `
  aspect-ratio: 757/418;
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
`;
//# sourceMappingURL=GroupPresentation.js.map